import type { Announcements, ScreenReaderInstructions } from '@dnd-kit/core'

import type { I18n } from '@/shared/i18n'

/**
 * Los anuncios de dnd-kit vienen en inglés y fijos.
 *
 * Un lector de pantalla que cambia de idioma a mitad de una fila es peor que no
 * anunciar nada, así que se reemplazan por los del catálogo — **en el idioma de
 * quien está arrastrando**, no en el de quien escribió el componente. Por eso
 * son funciones que reciben `t` en vez de constantes de módulo: una constante
 * se evalúa una vez, cuando todavía no se sabe quién va a mirar.
 */
export function createInstructions(t: I18n['t']): ScreenReaderInstructions {
  return { draggable: t('dnd.instructions') }
}

export function createAnnouncements(t: I18n['t'], kind: 'list' | 'board'): Announcements {
  const ambito = t(kind === 'list' ? 'dnd.scope.list' : 'dnd.scope.board')

  return {
    onDragStart: ({ active }) => t('dnd.announce.start', { item: String(active.id) }),
    onDragOver: ({ active, over }) =>
      over
        ? t('dnd.announce.over', { item: String(active.id), destino: String(over.id) })
        : t('dnd.announce.overInvalid', { item: String(active.id), ambito }),
    onDragEnd: ({ active, over }) =>
      over
        ? t('dnd.announce.end', { item: String(active.id), destino: String(over.id) })
        : t('dnd.announce.endNoChange', { item: String(active.id) }),
    onDragCancel: ({ active }) => t('dnd.announce.cancel', { item: String(active.id) }),
  }
}
